<template>
  <div class="sudo-login-splash" role="status" aria-live="polite" aria-busy="true">
    <div class="sudo-login-splash__content">
      <img
        src="/images/project-blue-logo.png"
        alt="Project Blue"
        class="sudo-login-splash__logo"
        width="200"
        height="auto"
      />
      <p class="sudo-login-splash__message">{{ message }}</p>
      <div class="sudo-login-splash__progress-track">
        <div class="sudo-login-splash__progress-fill" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { sudoLogin } from "../composables/auth";
import { ROUTES } from "../routes/names";
import { saveToUserLogs, userLogInputFields } from "@/composables/userLogs";

const route = useRoute();
const router = useRouter();
const message = ref("Signing you in...");

onMounted(async () => {
  const email = route.query.email;
  const auth0id = route.query.auth0id;
  const userGuid = route.query.userGuid;

  console.log("Sudo Login Parameters:");
  console.log("Email:", email);
  console.log("Auth0 ID:", auth0id);
  console.log("User GUID:", userGuid);

  if (email && auth0id && userGuid) {
    const credentials = {
      email: email,
      auth0id: auth0id,
      userGuid: userGuid,
    };

    const isAuthenticated = await sudoLogin(credentials);
    if (isAuthenticated) {
      console.log("Sudo login successful, redirecting to dashboard");
      message.value = "Loading Proxima...";
      userLogInputFields.value = {
        userEmail: credentials.email,
        description: `User ${credentials.email} successfully logged in to Proxima Blue.`,
        action: "Login",
        method: null,
        statusCode: 200,
        environment: window.location.hostname,
        endpoint: null,
        path: null,
      };
      await saveToUserLogs(userLogInputFields.value);
      router.push({ name: ROUTES.DASHBOARD.name });
    } else {
      console.log("Sudo login failed");
    }
  } else {
    console.log("Missing required parameters for sudo login");
    const emailForLog = email || "unknown";
    userLogInputFields.value = {
      userEmail: emailForLog,
      description: `User ${emailForLog} failed to log in to Proxima Blue. With error message: Missing required parameters for sudo login.`,
      action: "Login",
      method: null,
      statusCode: 500,
      environment: window.location.hostname,
      endpoint: null,
      path: null,
    };
    await saveToUserLogs(userLogInputFields.value);
  }
});
</script>

<style scoped>
.sudo-login-splash {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.sudo-login-splash__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
  padding: 2rem;
}

.sudo-login-splash__logo {
  max-width: 200px;
  height: auto;
  margin-bottom: 1.5rem;
}

.sudo-login-splash__message {
  font-family: "Gilroy", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #333;
  text-align: center;
  margin: 0 0 1.25rem;
}

.sudo-login-splash__progress-track {
  width: 240px;
  height: 6px;
  background-color: rgba(33, 60, 229, 0.15);
  border-radius: 3px;
  overflow: hidden;
}

.sudo-login-splash__progress-fill {
  height: 100%;
  width: 40%;
  background: linear-gradient(to right, #213ce5, #2380f2);
  border-radius: 3px;
  animation: sudo-login-progress 1.5s ease-in-out infinite;
}

@keyframes sudo-login-progress {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}
</style>
